import { PeopleRounded, PublicRounded } from '@mui/icons-material'
import { Typography } from '@mui/material'

function VisibilityIcon({ id }: { id: number }) {
  const visibilityValue = [<PeopleRounded fontSize="small" />, 'VIP', <PublicRounded fontSize="small" />]

  return (
    <Typography
      variant="caption"
      sx={{
        backgroundImage: 'linear-gradient(89.97deg, #D5B385 -12.76%, #B49568 113.26%)',
        fill: '#B49568',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      }}
    >
      {visibilityValue[id]}
    </Typography>
  )
}

export default VisibilityIcon
